<template>
  <div class="bottom-charts">
    <div class="bc-chart-item">
      <div class="bcci-header">办件类型</div>
      <dv-active-ring-chart :config="config1" />
      <Label-Tag :config="labelConfig1" />
    </div>
    <dv-decoration-2 class="decoration-1" :reverse="true" style="width:5px;" />

    <div class="bc-chart-item">
      <div class="bcci-header">是否进驻大厅</div>
      <dv-active-ring-chart :config="config2" />
      <Label-Tag :config="labelConfig2" />
    </div>

    <dv-decoration-2 class="decoration-2" :reverse="true" style="width:5px;" />

    <div class="bc-chart-item">
      <div class="bcci-header">到办事现场次数</div>
      <dv-active-ring-chart :config="config3" />
      <Label-Tag :config="labelConfig3" />
    </div>
  </div>
</template>

<script>
import LabelTag from './LabelTag'

export default {
  name: 'BottomCharts21',
  components: {
    LabelTag
  },
  data() {
    return {
      config1: {
        data: [
          {
            name: '',
            value: 12238
          },
          {
            name: '',
            value: 65282
          }
        ],
        radius: '70%', activeRadius: '70%', activeTimeGap: 100000,
        showOriginValue: false,
        digitalFlopStyle: {
          fontSize: 0,
        }, color: ['#00baff', '#3de7c9', '#ffc530', '#469f4b']
      },

      config2: {
        data: [
          {
            name: '',
            value: 5922
          },
          {
            name: '',
            value: 71598
          },
        ],
        radius: '70%', activeRadius: '70%', activeTimeGap: 100000,
        showOriginValue: false,
        digitalFlopStyle: {
          fontSize: 0,
        }, color: ['#00baff', '#3de7c9', '#ffc530', '#469f4b']
      },

      config3: {
        data: [
          {
            name: '',
            value: 65635
          },
          {
            name: '',
            value: 11743
          },
          {
            name: '',
            value: 142
          },
        ],
        radius: '70%', activeRadius: '70%', activeTimeGap: 100000,
        showOriginValue: true,
        digitalFlopStyle: {
          fontSize: 0,
        }, color: ['#00baff', '#3de7c9', '#ffc530', '#469f4b']
      },
      labelConfig1: {
        data: ['承诺件:12238', '即办件:65282'],
      },
      labelConfig2: {
        data: ['是:5922', '否:71598'],
      },
      labelConfig3: {
        data: ['0次:65635', '1次:11743', '1次以上:142'],
      },
    }
  }
}
</script>

<style lang="less">
.bottom-charts {
  width: 100%;
  height: 40%;
  display: flex;
  position: relative;

  .bc-chart-item {
    width: 32%;
    height: 60%;
    padding-top: 10px;
    box-sizing: border-box;
  }

  .bcci-header {
    height: 20px;
    text-align: center;
    line-height: 20px;
    font-size: 16px;
  }

  .dv-active-ring-chart {
    height: calc(~"100% - 20px");
    color: #000;
  }

  .label-tag {
    height: 10px;
    color: #000;
  }

  .active-ring-name {
    font-size: 14px !important;
  }

  .decoration-1,
  .decoration-2,
  .decoration-3 {
    display: absolute;
    left: 0%;
  }
}
</style>
